// extracted by mini-css-extract-plugin
module.exports = {"wrap":"InsuranceSettingMenus__wrap--2RyyY"};